export function initBioToggle() {
  document.querySelectorAll('[data-bio-toggle]').forEach(bio => {
    const btn = bio.querySelector('.bio-toggle');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const expanded = bio.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
    });
  });
}
